var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIcAguardandoBoleto = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;fill:none;stroke:#2ABA83;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:#2ABA83;}\r\n\t.st2{fill:#D4145A;}\r\n\t.st3{fill:#363636;}\r\n\t.st4{display:none;}\r\n\t.st5{display:inline;}\r\n\t.st6{fill:#30323A;}\r\n\t.st7{font-family:'Poppins-Regular';}\r\n\t.st8{font-size:3.9346px;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bolsas_e_Olheiras"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Hidratante"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Repelente"
  }, /*#__PURE__*/React.createElement("g", {
    id: "guias"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Barba"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Calv\\xEDcie"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Clareador"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Beleza"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Iluminador"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Preechedor"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Crescimento_Capilar"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Pesco\\xE7o_e_Colo"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Fortalecedor_de_Cabelo"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Sa\\xFAde"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Fortalecedor_de_Unha"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Protetor_Solar"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Texto"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.05,17.61c-2.73,0-4.95,2.22-4.95,4.95s2.22,4.95,4.95,4.95c2.73,0,4.95-2.22,4.95-4.95 S49.78,17.61,47.05,17.61z M47.05,26.52c-2.18,0-3.95-1.77-3.95-3.95s1.77-3.95,3.95-3.95S51,20.39,51,22.57 S49.23,26.52,47.05,26.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.68,20.33l-1.58,1.58l-1.12-1.12c-0.2-0.2-0.51-0.2-0.71,0s-0.2,0.51,0,0.71l1.48,1.48 c0.09,0.09,0.22,0.15,0.35,0.15s0.26-0.05,0.35-0.15l1.93-1.93c0.2-0.2,0.2-0.51,0-0.71S48.87,20.14,48.68,20.33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M47.35,28.17c-0.28,0-0.5,0.22-0.5,0.5v12.21c0,1.63-1.33,2.96-2.96,2.96H20.26c-1.63,0-2.96-1.33-2.96-2.96V26.54 c0-1.63,1.33-2.96,2.96-2.96h20.57c0.28,0,0.5-0.22,0.5-0.5s-0.22-0.5-0.5-0.5H20.26c-2.18,0-3.96,1.77-3.96,3.96v14.34 c0,2.18,1.77,3.96,3.96,3.96h23.63c2.18,0,3.96-1.77,3.96-3.96V28.67C47.85,28.39,47.62,28.17,47.35,28.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.34,26.53v14.35c0,0.28,0.22,0.5,0.5,0.5s0.5-0.22,0.5-0.5V26.53c0-0.28-0.22-0.5-0.5-0.5S20.34,26.26,20.34,26.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.99,26.53v14.35c0,0.28,0.22,0.5,0.5,0.5s0.5-0.22,0.5-0.5V26.53c0-0.28-0.22-0.5-0.5-0.5S21.99,26.26,21.99,26.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.52,26.53v14.35c0,0.28,0.22,0.5,0.5,0.5s0.5-0.22,0.5-0.5V26.53c0-0.28-0.22-0.5-0.5-0.5S25.52,26.26,25.52,26.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.06,26.53v14.35c0,0.28,0.22,0.5,0.5,0.5s0.5-0.22,0.5-0.5V26.53c0-0.28-0.22-0.5-0.5-0.5S29.06,26.26,29.06,26.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7,26.53v14.35c0,0.28,0.22,0.5,0.5,0.5s0.5-0.22,0.5-0.5V26.53c0-0.28-0.22-0.5-0.5-0.5S30.7,26.26,30.7,26.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.22,26.53v14.35c0,0.28,0.22,0.5,0.5,0.5s0.5-0.22,0.5-0.5V26.53c0-0.28-0.22-0.5-0.5-0.5S32.22,26.26,32.22,26.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5,26.53v14.35c0,0.28,0.22,0.5,0.5,0.5s0.5-0.22,0.5-0.5V26.53c0-0.28-0.22-0.5-0.5-0.5S35.5,26.26,35.5,26.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.14,26.53v14.35c0,0.28,0.22,0.5,0.5,0.5s0.5-0.22,0.5-0.5V26.53c0-0.28-0.22-0.5-0.5-0.5S37.14,26.26,37.14,26.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.82,26.03c-0.28,0-0.5,0.22-0.5,0.5v14.35c0,0.28,0.22,0.5,0.5,0.5s0.5-0.22,0.5-0.5V26.53 C41.32,26.26,41.1,26.03,40.82,26.03z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.46,41.38c0.28,0,0.5-0.22,0.5-0.5V28.53c0-0.28-0.22-0.5-0.5-0.5s-0.5,0.22-0.5,0.5v12.35 C42.96,41.15,43.18,41.38,43.46,41.38z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "label",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 10.5094 58.6176)",
    className: "st6 st7 st8"
  }, "AGUARDANDO BOLETO"))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcAguardandoBoleto, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-aguardando-boleto.3a407bcd.svg";
export { ForwardRef as ReactComponent };